import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
    const { t } = useI18n();
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setBusy(true);
        try {
            await login(email, password);
            toast.success("OK");
            const to = loc.state?.from || "/dashboard";
            nav(to, { replace: true });
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="bg-grain min-h-screen">
            <Navbar />
            <div className="max-w-md mx-auto px-4 py-20" data-testid="login-page">
                <h1 className="font-display text-4xl">{t.auth.loginTitle}</h1>
                <p className="text-brand-text/70 mt-2">{t.auth.loginSub}</p>
                <form onSubmit={submit} className="mt-8 space-y-4 rounded-3xl border border-brand-border bg-white p-7">
                    <AuthField label={t.auth.email} type="email" value={email} onChange={setEmail} testid="login-email" required />
                    <AuthField label={t.auth.password} type="password" value={password} onChange={setPassword} testid="login-password" required />
                    {error && <div className="text-sm text-brand-critical" data-testid="login-error">{error}</div>}
                    <button disabled={busy} type="submit" className="w-full py-3 rounded-full btn-primary font-semibold disabled:opacity-60" data-testid="login-submit">
                        {busy ? "..." : t.auth.login}
                    </button>
                    <div className="flex justify-between text-sm pt-2 text-brand-textMuted">
                        <Link to="/forgot-password" className="hover:text-brand-primary" data-testid="login-forgot">{t.auth.forgot}</Link>
                        <Link to="/register" className="hover:text-brand-primary" data-testid="login-to-register">{t.auth.noAccount} {t.auth.register}</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export function AuthField({ label, value, onChange, type = "text", testid, required }) {
    return (
        <label className="block">
            <span className="text-xs font-mono tracking-widest text-brand-textMuted uppercase">{label}</span>
            <input
                type={type}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                required={required}
                className="mt-2 w-full rounded-xl border border-brand-border bg-brand-bg px-4 py-3 text-sm focus:outline-none focus:border-brand-text transition"
                data-testid={testid}
            />
        </label>
    );
}
